var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"head"}},[_c('h1',[_vm._v("Pin "+_vm._s(_vm.name.slice(-3)))]),_c('div',{staticClass:"line-white"},[_vm._v(" "+_vm._s(_vm.$t('devices.battery'))),_c('br'),_c('img',{attrs:{"src":_vm.image,"height":"21","width":"33"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }